import KeyFeatures from './KeyFeatures';

export default KeyFeatures;
